import { Heading } from 'blaze-ui/Heading/Heading'
import { Provider } from '../Types'

interface Props {
  title?: string
  provider?: Provider
}

export const Title = ({ title, provider }: Props) => {
  if (!provider) return <Heading level={5}>{title || 'Add Media'}</Heading>

  return (
    <Heading level={5}>
      {
        {
          uploads: 'Uploaded Media',
          link: 'Add Media Link',
          stock: 'Stock',
          gifs: 'Gifs',
          ai: 'Generate Image',
          brandKits: 'Brand Kit',
        }[provider]
      }
    </Heading>
  )
}
